import { HttpErrorResponse } from '@angular/common/http';

function firstErrorString(value: unknown): string | undefined {
  if (typeof value === 'string' && value.trim()) {
    return value;
  }
  if (Array.isArray(value) && value.length > 0) {
    return firstErrorString(value[0]);
  }
  if (value && typeof value === 'object' && 'message' in value) {
    const message = (value as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }
  return undefined;
}

/** Extract a user-facing message from a failed API call (DRF / HttpClient errors). */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const body =
    error instanceof HttpErrorResponse
      ? error.error
      : error && typeof error === 'object' && 'error' in error
        ? (error as { error: unknown }).error
        : error;

  if (typeof body === 'string' && body.trim()) {
    return body;
  }

  if (Array.isArray(body)) {
    return firstErrorString(body) ?? fallback;
  }

  if (body && typeof body === 'object') {
    const record = body as Record<string, unknown>;
    for (const key of [
      'detail',
      'message',
      'error',
      'non_field_errors',
      'plan_name',
    ]) {
      const message = firstErrorString(record[key]);
      if (message) {
        return message;
      }
    }
    for (const [key, value] of Object.entries(record)) {
      if (key === 'errorId') {
        continue;
      }
      const message = firstErrorString(value);
      if (message) {
        return message;
      }
    }
  }

  return fallback;
}

export function isNullOrUndefined(value: unknown) {
  return value == undefined || value == null;
}

export function isNullOrUndefinedOrEmpty(value: string) {
  return value == undefined || value == null || value.trim() == '';
}

export function isValidGUID(guid: string): boolean {
  const guidRegex =
    /^[{(]?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[)}]?$/i;
  return guidRegex.test(guid);
}

export function getBaseRoute(url: string): string {
  return url.split('?')[0];
}

export function formatAddress(address: string): string {
  if (!address) return '';

  return address
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
